<template>
  <section id="intro">
    <div class="container">
      <div class="row">
        <div align="left" class="col-sm-12 col-md-8">
          <div class="intro-content box">
            <h2>Privacy Policy</h2>
            <p>
              We respect your privacy. This Privacy Policy governs the manner in which we will treat
              your personal information collected when using our website and when we otherwise
              engage with each after you visit our website.
            </p>
          </div>
        </div>
      </div>
    </div>

    <carousel
      :nav="false"
      :dots="false"
      :items="1"
      :autoplay="true"
      :loop="true"
      id="intro-carousel"
      style="margin-top:-50px"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <img class="item" src="/img/intro-carousel/home-1.jpg" style="object-fit: cover" alt="" />
      <img class="item" src="/img/intro-carousel/home-2.jpg" style="object-fit: cover" alt="" />
      <img class="item" src="/img/intro-carousel/home-3.jpg" style="object-fit: cover" alt="" />
      <img class="item" src="/img/intro-carousel/home-4.jpg" style="object-fit: cover" alt="" />
      <img class="item" src="/img/intro-carousel/home-5.jpg" style="object-fit: cover" alt="" />
      <img class="item" src="/img/intro-carousel/home-6.jpg" style="object-fit: cover" alt="" />
    </carousel>

    <div id="intro-carousel" class="owl-carousel"></div>
  </section>
</template>

<script>
/* eslint-disable */

import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  }
};
</script>

<style lang="scss" scoped></style>
